import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import MicNoneRoundedIcon from "@mui/icons-material/MicNoneRounded";
import StopRoundedIcon from "@mui/icons-material/StopRounded";

type Props = {
    isRecording: boolean;
    disabled?: boolean;
    onClick: () => void;
};

export const SrVoiceMicButton: React.FC<Props> = ({
    isRecording,
    disabled,
    onClick,
}) => (
    <Tooltip title={isRecording ? "Stop & send" : "Voice input"}>
        <span>
            <IconButton
                onClick={onClick}
                disabled={disabled}
                aria-label={isRecording ? "stop recording" : "voice"}
                sx={{
                    width: 34,
                    height: 34,
                    borderRadius: "10px",
                    backgroundColor: isRecording ? "#FEE2E2" : "transparent",
                    color: isRecording ? "#DC2626" : "#64748B",
                    border: isRecording
                        ? "1px solid #FECACA"
                        : "1px solid transparent",
                    "&:hover": {
                        backgroundColor: isRecording ? "#FECACA" : "#F1F5F9",
                        color: isRecording ? "#B91C1C" : "#0F172A",
                    },
                }}
            >
                {isRecording ? (
                    <StopRoundedIcon sx={{ fontSize: 18 }} />
                ) : (
                    <MicNoneRoundedIcon sx={{ fontSize: 18 }} />
                )}
            </IconButton>
        </span>
    </Tooltip>
);
